import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';

const Task = ( { aid, uid, meta, tasks, setCurrent } ) => {
    let params = useParams();
    const [ t, setTask ] = useState( {
        details: {},
        assoc: []
    } );

    useEffect( () => {
        setCurrent( { tid: params.tid } );

        if ( tasks[params.tid] ) {
            setTask( { 
                details: tasks[params.tid],
                associations: tasks[params.tid].assoc
            } );
        }
    }, [ params.tid, tasks, setCurrent ] );

    useEffect( () => {
        document.title = `Third Floor - ${t?.details?.name}`;
    }, [ t?.details?.name ] );

    return (
        <TFObject key={params.tid} objType='task' obj={t} oid={params.tid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.task,
    tasks: state.tasks.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.tasks.setCurrent
} );
  
export default connect( mapProps, mapDispatch )( Task );